module.exports = __webpack_public_path__ + "teqbahn-assets/media/12.b3cc8b24.png";